import { render, staticRenderFns } from "./YearsList.vue?vue&type=template&id=3d27e424&scoped=true&"
import script from "./YearsList.vue?vue&type=script&lang=js&"
export * from "./YearsList.vue?vue&type=script&lang=js&"
import style0 from "./YearsList.vue?vue&type=style&index=0&id=3d27e424&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d27e424",
  null
  
)

export default component.exports